export const PageHeader = ({ kicker, title, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 fade-up">
    <div>
      {kicker && <div className="text-xs font-mono-x uppercase tracking-[0.2em] text-emerald-700 mb-2">{kicker}</div>}
      <h1 className="font-heading text-4xl sm:text-5xl font-bold uppercase tracking-tight text-[#0B192C]">{title}</h1>
    </div>
    {children && <div className="flex gap-2 flex-wrap">{children}</div>}
  </div>
);

export const Panel = ({ children, className = "", ...rest }) => (
  <div className={`bg-white border border-slate-200 rounded-xl p-6 sm:p-8 ${className}`} {...rest}>
    {children}
  </div>
);

export const Empty = ({ children, ...rest }) => (
  <div className="border border-dashed border-slate-300 rounded-xl p-10 text-center text-muted-foreground bg-white/60" {...rest}>
    {children}
  </div>
);
